import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: "50px",
    height: "100%",
    textAlign: "center",
  },
  imgBox: {
    paddingLeft: "20px",
    maxWidth: "80%",
    maxHeight: "70%",
    margin: "10px",
  },
  img: {
    height: "70%",
    maxWidth: "60%",
  },
  input: {
    display: "none",
  },
  textBox: {
    paddingBottom: "5px",
    paddingLeft: "20px",
    paddingRight: "75px",
  },
}));

export { useStyles };
